import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface Order {
  id: string
  items: any[]
  total: number
  customerInfo: {
    phone: string
    branch: string
  }
  status: "pending" | "confirmed" | "preparing" | "ready" | "delivered"
  createdAt: string
}

interface OrderState {
  currentOrder: Order | null
  orderHistory: Order[]
}

const initialState: OrderState = {
  currentOrder: null,
  orderHistory: [],
}

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setCurrentOrder: (state, action: PayloadAction<Order>) => {
      state.currentOrder = action.payload
    },
    clearCurrentOrder: (state) => {
      state.currentOrder = null
    },
    addToHistory: (state, action: PayloadAction<Order>) => {
      state.orderHistory.push(action.payload)
    },
  },
})

export const { setCurrentOrder, clearCurrentOrder, addToHistory } = orderSlice.actions
export default orderSlice.reducer
